module.exports = __webpack_public_path__ + "f2a179aa465e91fe2b56c1f97fbccbfb.svg";